// extracted by mini-css-extract-plugin
module.exports = {"info-wrapper":"announcements_info-wrapper__2jKJn"};